//

// ******************************************************************
// * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. *
// ******************************************************************
import { DiscoveryApi } from '../types/discovery';
import { FetchApi } from '../types/fetch';
import crossFetch from 'cross-fetch';
import { pluginId } from '../pluginId';
import * as parser from 'uri-template';
import { ReadEvent } from '../models/ReadEvent.model';
import { UserPost200Response } from '../models/UserPost200Response.model';

/**
 * Wraps the Response type to convey a type on the json call.
 *
 * @public
 */
export type TypedResponse<T> = Omit<Response, 'json'> & {
  json: () => Promise<T>;
};

/**
 * Options you can pass into a request for additional information.
 *
 * @public
 */
export interface RequestOptions {
  token?: string;
}
/**
 * @public
 */
export type UserGet = {
  path: {
    user: string;
  };
  query: {
    docEntityRefFilter?: Array<string>;
    limit?: number;
    order?: 'asc' | 'desc';
  };
};
/**
 * @public
 */
export type UserPost = {
  path: {
    user: string;
  };
  body: ReadEvent;
};

/**
 * @public
 */
export class DefaultApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  /**
   *
   * @param user -
   * @param docEntityRefFilter -
   * @param limit -
   * @param order -
   */
  public async userGet(
    // @ts-ignore
    request: UserGet,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<ReadEvent>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/{user}{?docEntityRefFilter*,limit,order}`;

    const uri = parser.parse(uriTemplate).expand({
      user: request.path.user,
      ...request.query,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   *
   * @param user -
   * @param readEvent -
   */
  public async userPost(
    // @ts-ignore
    request: UserPost,
    options?: RequestOptions,
  ): Promise<TypedResponse<UserPost200Response>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/{user}`;

    const uri = parser.parse(uriTemplate).expand({
      user: request.path.user,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'POST',
      body: JSON.stringify(request.body),
    });
  }
}
